import { FormControlLabel, Switch } from '@mui/material';
import { Stack } from '@mui/system';
import { useCallback } from 'react';

type Props = {
  value: boolean;
  onChange: (failOnNoRouteFound: boolean) => void;
};

export const FailOnNoRouteFoundToggle = ({ value, onChange }: Props) => {
  const onToggleChange = useCallback(
    (e) => {
      onChange(e.target.checked);
    },
    [onChange],
  );

  return (
    <Stack sx={{ pr: 2 }}>
      <FormControlLabel
        labelPlacement='start'
        sx={{ marginLeft: 0 }}
        control={
          <Switch
            value={value}
            sx={{ marginLeft: 'auto' }}
            size='small'
            onChange={onToggleChange}
            checked={value}
          />
        }
        label='Fail on no route found'
      />
    </Stack>
  );
};
